/*
 * @Author: Vanny
 * @Date: 2019-12-17 11:32:37
 * @LastEditors  : Vanny
 * @LastEditTime : 2020-01-06 17:03:29
 * @Description:
 */
import Vue from 'vue'
import Toast from './Toast'

const ToastConstructor = Vue.extend(Toast)
const toastPool = []

const getAnInstance = () => {
  if (toastPool.length > 0) {
    const instance = toastPool[0]
    toastPool.splice(0, 1)
    return instance
  }
  return new ToastConstructor({
    el: document.createElement('div')
  })
}

const returnAnInstance = (instance) => {
  if (instance) {
    toastPool.push(instance)
  }
}

const removeDom = (event) => {
  if (event.target.parentNode) {
    event.target.parentNode.removeChild(event.target)
  }
}

ToastConstructor.prototype.close = function close() {
  this.visible = false
  this.$el.addEventListener('transitionend', removeDom)
  this.closed = true
  returnAnInstance(this)
}

const ToastWrapper = (options = {}) => {
  const duration = options.duration || 3000

  const instance = getAnInstance()
  instance.closed = false
  clearTimeout(instance.timer)
  instance.message =
    !options || typeof options !== 'object' ? options : options.message
  instance.position = options.position || 'middle'
  instance.className = options.className || ''
  instance.iconName = options.iconName || ''

  document.body.appendChild(instance.$el)
  Vue.nextTick(() => {
    instance.visible = true
    instance.$el.removeEventListener('transitionend', removeDom)
    if (duration > 0) {
      instance.timer = setTimeout(() => {
        if (instance.closed) return
        instance.close()
      }, duration)
    }
  })
  return instance
}

export default ToastWrapper
